// Angular Imports
import { NgIf } from '@angular/common'
import { Component, Input } from '@angular/core'
// Angular Material Imports
import { MatIconModule } from '@angular/material/icon'
// Shared Imports
import { EIcons, EIconSize, EIconSpace } from '@shared/models'

@Component({
	selector: 'app-icon',
	standalone: true,
	imports: [NgIf, MatIconModule],
	templateUrl: './icon.component.html',
	styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
	@Input({ required: true }) icon: EIcons = EIcons.adminPanelSettings
	@Input() iconSize: keyof typeof EIconSize = EIconSize.normal
	@Input() spaceDirection: keyof typeof EIconSpace = EIconSpace.none
	@Input() iconMoveTopToBotton: number = 0
	@Input() iconMoveLeftToRight: number = 0

	readonly EIconSize = EIconSize
	readonly EIconSpace = EIconSpace

	isSvgIcon(): boolean {
		return this.icon.endsWith('.svg') ? true : false
	}
}
